import { render, staticRenderFns } from "./giftDeliveryList.vue?vue&type=template&id=70adc5a0"
import script from "./giftDeliveryList.vue?vue&type=script&lang=js"
export * from "./giftDeliveryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports